module.exports = __webpack_public_path__ + "static/media/office-red-map.13a412ab.png";